import { Button, IconEdit3, Popover } from '@odekoteam/doppio';
import { Box } from 'theme-ui';

import Icon3Dots from '@/assets/images/Icon3Dots.svg?icon';
import IconTrash from '@/assets/images/IconTrash.svg?icon';
import { useDeleteMasterHomepageRowComponentMutation } from '@/graphql/types/generated';
import { useAppDispatch } from '@/hooks/store';
import { showToast, ToastAlertType } from '@/state/toast';

export function MasterHomepageRowComponentActionsMenu({
  rowId,
  onEdit,
  onDeleted,
  isDisabled,
  componentId,
}: {
  rowId: string;
  onEdit: () => void;
  componentId: string;
  isDisabled?: boolean;
  onDeleted: () => Promise<void> | void;
}) {
  const dispatch = useAppDispatch();
  const [{ fetching }, deleteMasterHomepageRowComponent] =
    useDeleteMasterHomepageRowComponentMutation();

  const handleDelete = async () => {
    const result = await deleteMasterHomepageRowComponent({
      input: { rowId, componentId },
    });
    if (result.error) {
      dispatch(
        showToast({
          duration: 4000,
          content: result.error.message,
          alertType: ToastAlertType.ERROR,
          header: 'Error deleting component',
        }),
      );
      return;
    }
    const errors =
      result.data?.deleteMasterHomepageRowComponent?.errors?.map(
        (error) => error.message,
      ) ?? [];
    if (errors.length > 0) {
      dispatch(
        showToast({
          duration: 4000,
          content: errors.join(', '),
          alertType: ToastAlertType.ERROR,
          header: 'Error deleting component',
        }),
      );
      return;
    }
    await onDeleted();
    dispatch(
      showToast({
        duration: 4000,
        header: 'Component deleted',
        alertType: ToastAlertType.SUCCESS,
        content: 'The collection has been removed from the row.',
      }),
    );
  };

  if (isDisabled) {
    return (
      <Button
        size="small"
        variant="tertiary"
        iconLeft={<Icon3Dots />}
        isDisabled
      />
    );
  }

  return (
    <Popover.Root>
      <Popover.Trigger>
        <Button size="small" variant="tertiary" iconLeft={<Icon3Dots />} />
      </Popover.Trigger>
      <Popover.Content align="right">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            m: -2,
            '& > *:last-child, & > *:last-child *': {
              color: '#F4230B !important',
            },
            '& > *': {
              width: '100% !important',
              justifyContent: 'flex-start !important',
            },
          }}
        >
          <Button
            size="small"
            variant="ghost"
            onPress={onEdit}
            iconLeft={<IconEdit3 />}
          >
            Edit
          </Button>
          <Button
            size="small"
            variant="ghost"
            isDisabled={fetching}
            iconLeft={<IconTrash />}
            onPress={() => handleDelete()}
          >
            Delete
          </Button>
        </Box>
      </Popover.Content>
    </Popover.Root>
  );
}
